import React from 'react';
import { CheckBox } from '@components/ui/form/checkbox';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '@i18n/client';
import useQueryParam from '@utils/use-query-params';
import { FilterItem, getFilterNameForLanguage } from '@framework/types';
import { useUI } from '@contexts/ui.context';

export type MultiKeyFilterProps = {
  lang: string;
  filterItems: FilterItem[];
};

export const MultiKeyFilter = ({ lang, filterItems }: MultiKeyFilterProps) => {
  const { t } = useTranslation(lang, 'common');
  const location = useLocation();
  const pathname = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  const { updateQueryParams, clearQueryParam } = useQueryParam(pathname ?? '/');
  const { closeFilter } = useUI();

  function handleItemClick(
    item: FilterItem,
    e: React.FormEvent<HTMLInputElement>,
  ): void {
    const { value } = e.currentTarget;
    const selected = !!searchParams?.get(item.key!);
    if (selected) {
      clearQueryParam([item.key!]);
    } else {
      updateQueryParams(item.key!, value);
    }
    closeFilter();
  }

  return (
    <div className="block">
      <div className="flex flex-col p-2 rounded-md border-border-base">
        {filterItems?.map((item) => (
          <CheckBox
            showBorder={false}
            key={`${item.label_en}-key-${item.id}`}
            label={getFilterNameForLanguage(item, lang)}
            name={getFilterNameForLanguage(item, lang).toLowerCase()}
            checked={!!searchParams?.get(item.key!)}
            value={item.slug}
            onChange={(e) => handleItemClick(item, e)}
            lang={lang}
          />
        ))}
      </div>
    </div>
  );
};
